import React from 'react';
import PropTypes from 'prop-types';
import SearchUnavailableHeader from './SearchUnavailableHeader';
import SearchUnavailableIllustration from './SearchUnavailableIllustration';
import SearchUnavailableContent from './SearchUnavailableContent';
import './SearchUnavailable.scss';

const SearchUnavailable = ({ isApiError }) => {
	if (!isApiError) return null;

	return (
		<div className="locations-search-unavailable d-flex flex-column align-items-center justify-content-center text-center p-4">
			<SearchUnavailableHeader />
			<SearchUnavailableIllustration />
			<SearchUnavailableContent />
		</div>
	);
};

SearchUnavailable.propTypes = {
	isApiError: PropTypes.bool.isRequired
};

export default SearchUnavailable;
